// extracted by mini-css-extract-plugin
module.exports = {"tab":"Clusters_tab__1_qZf"};